export function debounce<F extends (...params: any[]) => void>(fn: F, delay: number) {
    let timeoutID: any = null;
    return (...args: any[]) => {
        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => { fn(...args); }, delay);
    };
}
